import { inject, Injectable, signal } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'
import { ErrorLogService } from '@shared/services/error-log.service'

@Injectable({
  providedIn: 'root',
})
export class ErrorMessageService {
  private readonly hideDelay = 10000
  private errorLogService = inject(ErrorLogService)

  #error = signal<string | null>(null)
  error = this.#error.asReadonly()

  handleError(errorResponse: HttpErrorResponse | undefined, showError = true) {
    let errorMessage = ''
    if (errorResponse) {
      this.errorLogService.log(errorResponse, 'ErrorMessageService', '')

      const status = errorResponse.status
      if (status >= 400 && status < 500) {
        errorMessage = errorResponse?.error?.error?.alias ?? errorResponse?.error?.message ?? ''
      }
      if (status >= 500 && status <= 600) {
        errorMessage = `The server is not available atm: ${errorResponse.message}`
      }
    }
    if (showError) {
      this.#error.set(errorMessage === '' ? null : errorMessage)
    }
    setTimeout(() => this.#error.set(null), this.hideDelay)
    return errorMessage
  }

  showError(error: string) {
    this.#error.set(error)
  }
}
